import React from 'react';
import { I18nManager, Platform } from 'react-native';
import RNRestart from 'react-native-restart';
import { setupI18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { I18nProvider } from '@lingui/react';
import moment from 'moment-jalaali';
// @ts-ignore
import fa from 'moment/locale/fa';
import * as yup from 'yup';

import useLanguage from '@src/hooks/useLanguage';
import { Language } from '@src/store/ui/types';

export const localesNames = ['فارسی', 'English'];
export const locales: Language[] = ['fa', 'en'];

export const i18n = setupI18n({
  locale: 'fa',
  locales,
  localeData: {
    fa: {
      plurals: () => null,
    },
    en: {
      plurals: () => null,
    },
  },
  messages: {
    fa: require('./locales/fa').messages,
    en: require('./locales/en').messages,
  },
});

const Component: React.FC = ({ children }) => {
  const language = useLanguage();
  const ref = React.useRef(i18n);
  const reload = React.useCallback(() => {
    if (Platform.OS === 'ios') {
      setTimeout(RNRestart.Restart, 1000);
    } else if (Platform.OS === 'android') {
      RNRestart.Restart();
    }
  }, []);

  React.useEffect(() => {
    ref.current.activate(language);

    yup.setLocale({
      mixed: {
        required: ({ path }) => ref.current._(t`${path} is required`),
      },
    });

    switch (language) {
      case 'fa':
        if (!I18nManager.isRTL) {
          I18nManager.allowRTL(true);
          I18nManager.forceRTL(true);
          reload();
        }
        moment.updateLocale(language, fa);
        moment.loadPersian({
          dialect: 'persian-modern',
          usePersianDigits: true,
        });
        moment.locale(language);
        return;
      default:
        if (I18nManager.isRTL) {
          I18nManager.allowRTL(false);
          I18nManager.forceRTL(false);
          reload();
        }
        moment.locale('en');
    }
  }, [language, reload]);

  return <I18nProvider i18n={ref.current}>{children}</I18nProvider>;
};

export const i18yup = yup;

Component.displayName = 'I18n';

export default Component;
